import { h } from 'preact';

import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import styles from './global.css';

export default function FormAndList(props) {
  const { list, form, formTitle, listTitle } = props;
  return (
    <>
      {form && (
        <Paper className={styles.originArea}>
          <Typography variant="h5" sx={{ mb: 3, mt: 1 }}>
            {formTitle}
          </Typography>
          {form}
        </Paper>
      )}
      <Paper className={styles.originArea}>
        <Typography variant="h5" sx={{ mb: 3, mt: 1 }}>
          {listTitle}
        </Typography>
        {list}
      </Paper>
    </>
  );
}
